<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M0,1C0,1,0,7,0,7C0,7,7,7,7,7C7,7,7,0,7,0C7,0,1,0,1,0C0.45,0,0,0.45,0,1C0,1,0,1,0,1ZM0,15C0,15.55,0.45,16,1,16C1,16,7,16,7,16C7,16,7,9,7,9C7,9,0,9,0,9C0,9,0,15,0,15C0,15,0,15,0,15ZM15,0C15,0,9,0,9,0C9,0,9,7,9,7C9,7,16,7,16,7C16,7,16,1,16,1C16,0.45,15.55,0,15,0C15,0,15,0,15,0ZM9,16C9,16,15,16,15,16C15.55,16,16,15.55,16,15C16,15,16,9,16,9C16,9,9,9,9,9C9,9,9,16,9,16C9,16,9,16,9,16Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'GridView',
} as DefineComponent
</script>
